module.exports = __webpack_public_path__ + "img/theme-dark.974c4260.png";